import { SITE_URL, altLinks, localePath, type Lang } from '../../lib/i18n';
import { TOOLS, hubStrings, toolPath, breadcrumbLd } from '../../lib/tools';
import { BlogHeader } from '../../components/BlogHeader';
import { Footer } from '../../components/Footer';
import { Seo } from '../../components/Seo';
import { Breadcrumbs, ToolHeroText } from '../../components/tools/ToolParts';

export default function ToolsHub({ lang = 'en' as Lang }: { lang?: Lang }) {
  const h = hubStrings(lang);
  const url = `${SITE_URL}${localePath(lang, '/tools')}`;
  const tools = TOOLS.map((tool) => ({ ...tool, ...h.tools[tool.id], href: toolPath(lang, tool.slug) }));
  return (
    <div className="min-h-screen bg-dark">
      <Seo
        title={h.metaTitle}
        description={h.metaDescription}
        canonical={url}
        lang={lang}
        alternates={altLinks('/tools')}
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            name: h.h1,
            itemListElement: tools.map((t, i) => ({ '@type': 'ListItem', position: i + 1, name: t.name, url: `${SITE_URL}${t.href}` })),
          },
          breadcrumbLd([
            { name: h.home, url: `${SITE_URL}${localePath(lang, '/')}` },
            { name: h.navLabel, url },
          ]),
        ]}
      />
      <BlogHeader lang={lang} />
      <main className="container mx-auto px-4 sm:px-6 py-10 md:py-14 max-w-5xl">
        <Breadcrumbs lang={lang} />
        <ToolHeroText eyebrow={h.eyebrow} h1={h.h1} intro={h.intro} />
        <ul className="grid sm:grid-cols-2 gap-4">
          {tools.map((t) => (
            <li key={t.id}>
              <a href={t.href} className="card-chunky is-hoverable block h-full p-6">
                <span className="chip-icon w-12 h-12 text-2xl mb-4" aria-hidden="true">{t.emoji}</span>
                <h2 className="text-xl font-black text-ink mb-2">{t.name}</h2>
                <p className="text-muted text-sm leading-relaxed mb-4">{t.description}</p>
                <span className="font-bold text-[var(--brand-ink)]">{h.open} →</span>
              </a>
            </li>
          ))}
        </ul>
      </main>
      <Footer lang={lang} />
    </div>
  );
}
